import { privateAPI } from '.';

export const pendingPasswordRequestAPI = privateAPI.injectEndpoints({
  endpoints: build => ({
    passwordRequestList: build.query({
      query: params => ({
        url: '/client-portal/password-request',
        method: 'GET',
        params: {
          page: params?.page || 1,
        },
      }),
      providesTags: ['passwordRequestsList'],
    }),
    markPasswordRequestsAsRead: build.mutation({
      query: ({ passwordRequestId } = {}) => ({
        url: '/client-portal/password-request/mark-as-read',
        method: 'POST',
        body: passwordRequestId ? { password_request_id: passwordRequestId } : undefined,
      }),
    }),
  }),
});

export const { usePasswordRequestListQuery, useMarkPasswordRequestsAsReadMutation } = pendingPasswordRequestAPI;
